import { useBrandingContext } from '@group-link-one/gl-components';
import type { JSX } from 'react';

import {
  ArtContainer,
  ContentContainer,
  Footer,
  LeftContainer,
  Logo,
  LogoContainer,
  MainContainer,
  RightContainer,
} from './Onboard.template.style';
import type { IBranding } from '@/Branding/_Types/Branding.types';

const OnboardTemplate = (props: IBranding & { children: React.ReactNode }): JSX.Element => {
  const { isDarkMode } = useBrandingContext();

  return (
    <main className={MainContainer}>
      <section className={LeftContainer}>
        <picture>
          <source
            media='(max-width: 768px)'
            srcSet={isDarkMode ? props.Onboard.art_mobile_dark : props.Onboard.art_mobile}
          />
          <img
            className={ArtContainer}
            src={isDarkMode ? props.Onboard.art_desktop_dark : props.Onboard.art_desktop}
            alt={`${props.BrandingName} Art`}
          />
        </picture>
      </section>

      <section className={RightContainer}>
        <div className={LogoContainer}>
          <img
            className={Logo}
            src={isDarkMode ? props.Onboard.logo_dark : props.Onboard.logo}
            alt={`${props.BrandingName} Logo`}
          />
        </div>
        <div className={ContentContainer}>{props.children}</div>
        <footer className={Footer}>
          © {new Date().getFullYear()} {props.BrandingName}
        </footer>
      </section>
    </main>
  );
};

export { OnboardTemplate };
